import { VList } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SideBarTemplate',{scopedSlots:_vm._u([{key:"items",fn:function(){return [_c(VList,{attrs:{"nav":"","flat":"","data-cy":"side-bar-main-list"}},[_vm._l((_vm.mainItems),function(item,i){return [_c('side-bar-item',{key:`item-${i}`,attrs:{"item":item,"id":`item-${i}`},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(item.tablerIcon,{tag:"component"})]},proxy:true}],null,true)})]})],2)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }